export default "__VITE_ASSET__C7Y0BS2k__"